import { render, staticRenderFns } from "./AvailableTemplates.vue?vue&type=template&id=23f964dc&"
import script from "./AvailableTemplates.vue?vue&type=script&lang=js&"
export * from "./AvailableTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports